import { useEffect, useState, useRef } from "react";
import "./AccommodationData.scss";
import { Form, Input, InputNumber, Select, Spin } from "antd";
import { getEventXRoomType } from "../../services/RoomTypeService";
import { AxiosResponse } from "axios";
import { getParticipantRoomNumber } from "../../services/RegistrationService";
import { ParticipantDto } from "../../models/Participant";
import { UpdateEventXRoomTypeCreate } from "../../models/EventXRoomTypeDto";
import { updateOneParticipantWithRoomKind } from "../../services/ParticipantService";
import { Toast } from "primereact/toast";

export type OptionsArray = {
  label: string;
  value: string;
  id: string;
};

const AccommodationData = (props: any) => {
  const [form] = Form.useForm();
  const Option = Select.Option;
  const [getSingleRoomType, setGetSingleRooomType] =
    useState<UpdateEventXRoomTypeCreate>();
  const [additionalPersonInRoom, setAdditionalPersonInRoom] = useState<
    ParticipantDto[]
  >([]);
  const [roomKindOptions, setRoomKindOptions] = useState([]);
  const [activeSpinner, setActiveSpinner] = useState(false);
  const toast = useRef<any>(null);

  const accommodationArray = [
    {
      label: "Zlatibor",
      value: "Zlatibor",
      id: "Zlatibor",
    },
    {
      label: "Kopaonik",
      value: "Kopaonik",
      id: "Kopaonik",
    },
  ];

  const roomTypesOptions = [
    {
      label: "Superior",
      value: "Superior",
      id: "Superior",
    },
    {
      label: "Lux",
      value: "Lux",
      id: "Lux",
    },
  ];

  useEffect(() => {
    let newMapRoomKind = props?.oneParticipant?.event?.roomKind?.map(
      (el: any) => {
        return { label: el.name, value: el.id, id: el.id };
      }
    );
    setRoomKindOptions(newMapRoomKind);
  }, [props]);

  useEffect(() => {
    if (props?.oneParticipant?.registration?.roomTypeId !== null) {
      getEventXRoomType(props?.oneParticipant?.registration?.roomTypeId).then(
        (res: AxiosResponse) => {
          setGetSingleRooomType(res.data.result);
        }
      );
    }

    getParticipantRoomNumber(props?.oneParticipant?.registration?.roomId).then(
      (res: AxiosResponse) => {
        setAdditionalPersonInRoom(res.data.result);
      }
    );
  }, [props]);

  return (
    <div className="accommodation-data">
      <Toast ref={toast} position={"top-right"} />
      <Spin spinning={activeSpinner}>
        <Form
          form={form}
          name="new-legal-entity-form"
          layout="vertical"
          autoComplete="off"
        >
          <div className="inner-box">
            <Form.Item
              className="selection"
              name={"accommodationId"}
              label="Smeštaj:"
            >
              <Select
                placeholder="Izaberite smeštaj"
                defaultValue={
                  props?.oneParticipant?.registration?.accommodation?.name
                }
                disabled
              >
                {accommodationArray.map((el: OptionsArray, i: number) => (
                  <Option key={el.id} value={el.id}>
                    {el.value}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="companyAddress" label="Adresa smeštaja:">
              <Input
                className="input-label"
                placeholder="Unesite adresu smeštaja"
                disabled
                defaultValue={
                  props?.oneParticipant?.registration?.accommodation?.address
                }
              />
            </Form.Item>

            <Form.Item name="roomNumber" label="Broj sobe:">
              <Input
                className="input-label"
                disabled
                defaultValue={props?.oneParticipant?.roomNumber || ""}
              />
            </Form.Item>

            <Form.Item
              className="inner-selection"
              name={"roomType"}
              label="Tip sobe:"
            >
              {getSingleRoomType && (
                <Select
                  placeholder="Tip sobe"
                  defaultValue={getSingleRoomType?.roomType?.name || ""}
                  disabled
                >
                  {roomTypesOptions.map((el: OptionsArray, i: number) => (
                    <Option key={el.id} value={el.id}>
                      {el.value}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>

            <span style={{ display: "flex" }}>
              <Form.Item
                className="first-input"
                name={"numberOfDays"}
                label="Broj noćenja:"
                style={{ width: "70%", marginRight: "10px" }}
              >
                <Input
                  type="text"
                  className="input-label"
                  defaultValue={
                    props?.oneParticipant?.registration?.numberOfDays
                  }
                  disabled
                />
              </Form.Item>
              <Form.Item name="roomNumber" label="Potreban parking:">
                <Input
                  type="checkbox"
                  className="input-label"
                  disabled
                  defaultValue={
                    props?.oneParticipant?.registration?.parkingPlace
                  }
                />
              </Form.Item>
            </span>
            <Form.Item
              name={"priceOfAccommodation"}
              className="disabled-field"
              label="Ukupna cena smestaja:"
            >
              <InputNumber
                style={{ width: "100%" }}
                defaultValue={
                  props?.oneParticipant?.registration?.priceOfAccommodation
                }
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
                disabled
              />
            </Form.Item>

            {additionalPersonInRoom?.map((person: ParticipantDto) => {
              if (props.oneParticipant.registration.id === person.id) {
                return null; // Preskoči ovu osobu
              }
              return (
                <Form.Item
                  name={person?.firstName}
                  className="disabled-field"
                  label="Ostale osobe u sobi:"
                >
                  <Input
                    type="text"
                    className="input-label"
                    defaultValue={person?.firstName}
                    disabled
                  />
                </Form.Item>
              );
            })}

            <Form.Item
              name={"priceOfAccommodation"}
              className="disabled-field"
              label="Cena kotizacije:"
            >
              <InputNumber
                style={{ width: "100%" }}
                defaultValue={props?.oneParticipant?.event?.registrationFee}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
                disabled
              />
            </Form.Item>

            <Form.Item
              name={"dinnerFee"}
              className="disabled-field"
              label="Cena svecane vecerPromena statusa prijavee:"
            >
              <InputNumber
                style={{ width: "100%" }}
                defaultValue={props?.oneParticipant?.event?.dinnerFee}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
                disabled
              />
            </Form.Item>

            <Form.Item
              name={"priceOfAccommodation"}
              className="disabled-field"
              label="Ukupna cena prijave:"
            >
              <InputNumber
                style={{ width: "100%" }}
                defaultValue={
                  parseInt(
                    props?.oneParticipant?.registration?.priceOfAccommodation ||
                      0
                  ) +
                  parseInt(props?.oneParticipant?.event?.registrationFee || 0)
                }
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                } //@ts-ignore
                parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
                disabled
              />
            </Form.Item>
            {props?.oneParticipant?.active ? (
              <Form.Item
                className="inner-selection"
                name={"roomKind"}
                label="Tip sobe:"
              >
                {props?.oneParticipant?.event?.roomKind && (
                  <Select
                    placeholder="Tip sobe"
                    defaultValue={props?.oneParticipant?.roomKind?.name || ""}
                    onChange={(option) => {
                      setActiveSpinner(true);
                      updateOneParticipantWithRoomKind(
                        props.oneParticipant.id,
                        option
                      )
                        .then((res: AxiosResponse) => {
                          setActiveSpinner(false);
                          toast?.current?.show({
                            severity: "success",
                            detail: `Uspešno sačuvan tip sobe!`,
                            life: 3000,
                          });
                        })
                        .catch((err: any) => {
                          setActiveSpinner(false);
                          let text = err.response.data.message;
                          toast?.current?.show({
                            severity: "error",
                            detail: `${text}`,
                            life: 3000,
                          });
                        });
                    }}
                  >
                    {roomKindOptions?.map((el: OptionsArray, i: number) => (
                      <Option key={el.id} value={el.value}>
                        {el.label}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            ) : (
              <Form.Item
                className="inner-selection"
                name={"roomKind"}
                label="Tip sobe:"
              >
                {props?.oneParticipant?.event?.roomKind && (
                  <Select
                    disabled
                    placeholder="Tip sobe"
                    defaultValue={props?.oneParticipant?.roomKind?.name || ""}
                    onChange={(option) => {
                      setActiveSpinner(true);
                      updateOneParticipantWithRoomKind(
                        props.oneParticipant.id,
                        option
                      )
                        .then((res: AxiosResponse) => {
                          setActiveSpinner(false);
                          toast?.current?.show({
                            severity: "success",
                            detail: `Uspešno sačuvan tip sobe!`,
                            life: 3000,
                          });
                        })
                        .catch((err: any) => {
                          setActiveSpinner(false);
                          let text = err.response.data.message;
                          toast?.current?.show({
                            severity: "error",
                            detail: `${text}`,
                            life: 3000,
                          });
                        });
                    }}
                  >
                    {roomKindOptions?.map((el: OptionsArray, i: number) => (
                      <Option key={el.id} value={el.value}>
                        {el.label}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            )}
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default AccommodationData;
